var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Navigation',{staticClass:"d-flex",attrs:{"navigationItemList":_vm.confTourModelsItems,"data":_vm.data},on:{"selectNavigationItem":_vm.setActiveItem}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e91375c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/alternative/configurableTour/components/ConfTourModelsBody.vue
// module id = null
// module chunks = 